import { serverAxios } from '@/shared/api';
import { GrassProps } from '@/shared/types';

interface GetProfileActionLogApiParams {
  isCurrent: boolean;
}

export const getProfileActionLogApi = ({
  isCurrent,
}: GetProfileActionLogApiParams) => {
  return serverAxios.get<GrassProps>('/yozmit/profiles/action-log/', {
    params: {
      is_current: isCurrent,
    },
  });
};
